<template> 
  <div class="top">
    <div class="s_flex_center m-r-50">
      <img class="width-22 height-22 mr5" src="../assets/images/headuser.png" alt="">
      <a @click="e => e.preventDefault()">
        <div style='color:#fff' class='m-r-10'> 您好，{{info.overView.company}}</div>
      </a>
      <div @click='loginOut' class="s_shou s_flex_ali"><img class="width-18 height-14" src="../assets/images/tuichu.png" alt=""></div>
    </div>
    <div class='s_flex_center'>
      <ul class="s_flex_ali">
        <li @click="handleMenu('/businessCenter')">商户中心</li>
        <li class="height-10" style="border-left: 1px solid #fff;"></li>
        <li @click="handleMenu('/system')">系统设置</li>
        <!-- <li class="height-10" style="border-left: 1px solid #fff;"></li>
        <li @click="handleMenu('/exportCenter')">导出中心</li> -->
      </ul>
    </div>
  </div>
  <div class='header'>
    <div class='headTop'>
      <div class='headerTop'>
        <div class='headerTopMain'>
          <div class='headerMenu'>
            <div>
              <ul role="menu" class="ant-menu-light ant-menu-root ant-menu ant-menu-horizontal">
                <li role="menuitem" class=" ant-menu-item" :class="active=='/index'?'ant-menu-item-selected':''"
                  @click="handleMenu('/index')">
                  <p class='fz-16'>首页</p>
                </li>
                <li role="menuitem" class=" ant-menu-item" :class="active=='/product'?'ant-menu-item-selected':''"
                  @click="handleMenu('/product')">
                  <p class='fz-16'>产品库</p>
                </li>
                <li role="menuitem" class=" ant-menu-item" :class="active=='/members'?'ant-menu-item-selected':''"
                  @click="handleMenu('/members')">
                  <p class='fz-16'>会员</p>
                </li>
                <li role="menuitem" class=" ant-menu-item" :class="active=='/customer'?'ant-menu-item-selected':''"
                  @click="handleMenu('/customer')">
                  <p class='fz-16'>渠道</p>
                </li>
                <li role="menuitem" class=" ant-menu-item" :class="active=='/assets'?'ant-menu-item-selected':''"
                  @click="handleMenu('/assets')">
                  <p class='fz-16'>资产</p>
                </li>
                <li role="menuitem" class=" ant-menu-item" :class="active=='/wxPublic'?'ant-menu-item-selected':''"
                  @click="handleMenu('/wxPublic')">
                  <p class='fz-16'>公众号</p>
                </li>
                <li role="menuitem" class=" ant-menu-item" :class="active=='/order'?'ant-menu-item-selected':''"
                  @click="handleMenu('/order')">
                  <p class='fz-16'>订单</p>
                </li>
                <li role="menuitem" class=" ant-menu-item application">
                  <p class='fz-16'>应用服务</p>
                  <div class="hideMenuBox" ref='hideBox'>
                    <div v-for="(value,index) in appList" :key="index">
                      <div class="hideMenuTitle">
                        <img :src="require('@/assets/images/'+value.src)" alt="" style="width:50px" class="mb10">
                        {{value.module}}
                      </div>
                      <div class="hideMenuList s_flex_ali s_flex_wrap">
                        <div class="m-r-25 s_flex_ali s_flex_fdc hideMenuItem" v-for="(item,key) in value.children"
                          :key="key" style="margin-bottom:20px">
                          <!-- ()=> {;active=null} v-if=""-->
                          <div @click="linkMenu(item)" class='s_flex_fdc s_flex_center fz-13 '
                            :class="item.is_Development||!item.is_open?'disabled':''">
                            <img :src="require('@/assets/images/index/'+item.icon)" alt=""
                              class="width-35 height-35 m-b-10">
                            {{item.name}}
                          </div>
                          <!-- <a :href="item.url" class='s_flex_fdc s_flex_center fz-13 s_cC5D2C1' target="_blank" v-else>
                            <img :src="require('@/assets/images/index/'+item.icon)" alt="" class="with-30">
                            {{item.name}}
                          </a> -->
                        </div>
                      </div>
                    </div>
                    <!-- <div class="p-b-20 s_flex_center s_wid100" style="position: absolute;left: 0;bottom: 0;"
                      @click="handleMenu('/orderApps')">
                      <div class="orderApps s_flex_center fz-16">+订购应用</div>
                    </div> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { onMounted, ref ,inject} from "vue";
  import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
  import { message } from "ant-design-vue";
  import config from '@/config'
  import { getToken } from '@/libs/util'
  import store from '@/store'
  import {getPanelLists} from '@/api/index'
  import { getMenu } from "@/api/public";
  import { iscode } from "@/utils/app";
  export default {
    name: "headerMenu",
    props: {
      info: {
        require: true,
        type: Object,
      },
      menu: {
        type: Array,
      },
      loginOut: {
        required: true,
        type: Function,
      },
    },
    setup(props) {
      const sysMenus={
        base:[],
        application:[],
        topMenus:[]
      }
      var appList = ref([
        {
          module: "人",
          src: 'group.png',
          children: [
            {
              url: "/messageCenter/miniTemplate",
              type: "inside",
              auth: "messageCenter",
              icon: "yingyong@2x.png",
              name: "消息管理",
              is_open:true
            },
            {
              url: "",
              type: "inside",
              auth: "",
              icon: "crmUse.png",
              name: "CRM",
              is_Development: true,
            },
            {
              url: "",
              type: "inside",
              is_Development: true,
              auth: "",
              icon: "ad.png",
              name: "数字广告",
            },
          ],
        },
        {
          module: "货",
          src: 'productData.png',
          children: [
            {
              url: "/qrcode/batch/index",
              type: "inside",
              auth: "code",
              icon: "qrcode.png",
              name: "二维码管理",
              is_open:true
            },
            {
              url: "/marketing/index",
              type: "inside",
              auth: "marketing",
              icon: "code.png",
              name: "智能营销",
              is_open:true
            },
            {
              url: "/antiFleeingGoods/index",
              type: "inside",
              auth: "antiFleeingGoods",
              icon: "arrear.png",
              name: "智能防窜",
              is_open:true
            },
            {
              url: "/guide/index",
              type: "inside",
              auth: "guide",
              icon: "guide.png",
              name: "超级导购",
              is_open:true
            },
          ],
        },
        {
          module: "场",
          src: 'viewData.png',
          children: [
            {
              url: config.cloudUrl[process.env.VUE_APP_type] + '?picdomain=' + store.state.user.info.picdomain + '&token=' + getToken()+'&brand_mark='+store.state.user.info.brand_mark,
              type: "outside",
              auth: "cloudManagement",
              icon: "yundian@2x.png",
              name: "直播云店",
              is_open:true
            },
            {
              url: "/onlineOrder/index",
              type: "inside",
              auth: "onlineOrder",
              icon: "onlineOrder.png",
              name: "在线订货",
              is_open:true
            },
         
            {
              url: "/integralShop/index",
              type: "inside",
              auth: "integralShop",
              icon: "integral.png",
              name: "积分商城",
              is_open:true
            },
               {
              url: "",
              type: "inside",
              auth: "",
              icon: "sysStore.png",
              is_Development: true,
              name: "电商通",
            },
          ],
        },
      ]);
      var $router = useRouter();
      var active = ref("/index");
      var path = useRoute().path;
      if (path.path) {
        path = path.path
      }
      // 动态绑定选中的值
      props.menu.forEach((v) => {
        if (!path || path == '/index') return
        if ('/'+path.split('/')[1]== v.url) {
          store.commit("user/SET_ASIDE_MENU", v.children);
          active.value = v.url;
        }
      });
      onBeforeRouteUpdate(to => {
        var toPath = to
        var paths = toPath.path.split('/')[1]
        var menu = store.state.user.info ? store.state.user.info.menu : [];
        var newMenu = []
        console.log(paths)
        if (menu.length && paths && paths != 'index') {
          menu.forEach((v) => {
            if ('/'+paths == v.url) {
              newMenu =v.children
            }
          });
        }
        console.log(newMenu)
        store.commit("user/SET_ASIDE_MENU", newMenu);
      })
      // 选中菜单后
      const handleMenu = (url) => {
        var flag = false;
        active.value = url;
        if (url == "/index") {
          if (props.menu.findIndex(v=>v.url == "/index") == -1) {
            message.error("抱歉未匹配到你对应的权限");
            return false;
          }
          store.commit("user/SET_ASIDE_MENU", props.menu[0]);
          $router.push(url);
          return
        }
        var linkPath = ''
        var newMenu = []
        for (let i = 0; i < props.menu.length; i++) {
          if (url === props.menu[i].url && props.menu[i].children) {
            newMenu = props.menu[i].children
            flag = true;
            if (props.menu[i].children[0] && props.menu[i].children[0].children.length) {
              if(props.menu[i].children[0].children[0].hidden == 1){
                linkPath = props.menu[i].children[0].url
              }else{
                linkPath = props.menu[i].children[0].children[0].url
              }
            } else {
              linkPath = props.menu[i].children[0].url
            }
          }
        }
        if (!flag) {
          message.error("抱歉未匹配到你对应的权限");
          return false;
        }
        store.commit("user/SET_ASIDE_MENU", newMenu);
        $router.push(linkPath);
      };
      // 递归处理成一个数据集合
      const rulesHandle = (data, list) => {
        data.forEach(element => {
          list.push(element.auth)
          if (element.children && element.children.length) {
            rulesHandle(element.children, list)
          }
        });
        return list
      }
      const hideBox = ref();
      const _lodash = inject("_lodash");
      // 跳转
      const linkMenu = async(item) => {
        if (item.is_Development||!item.is_open) return
        const hide = message.loading("正在加载中...", 0);
        let auth_item;
        let result = await getMenu({app_id:item.app_mark}).then((res) => res.data).catch((error) => error);
        setTimeout(hide);
        if (iscode(result)) {
          auth_item = result.data.find(v=> v.url == item.auth_url);
          if (!auth_item) {
            message.error("抱歉未匹配到你对应的权限！");
            return;
          }
        }
        if(item.auth=='cloudManagement'){
          window.open(config.cloudUrl[process.env.VUE_APP_type] + '?picdomain=' + store.state.user.info.picdomain + '&token=' + getToken()+'&brand_mark='+store.state.user.info.brand_mark)
          return
        }
        if(auth_item){
          var openUrl = '';
          if (auth_item.children[0] && auth_item.children[0].children.length) {
            if(auth_item.children[0].children[0].hidden == 1){
              openUrl = auth_item.children[0].url
            }else{
              openUrl = auth_item.children[0].children[0].url
            }
          } else {
            openUrl = auth_item.children[0].url
          }
          if (item.type == 'inside') {
            window.open(openUrl)
            active.value = ''
            hideBox.value.style.display = 'none'
            setTimeout(() => {
              hideBox.value.style = ''
            }, 100)
          } else {
            window.open(openUrl)
          }
        }
      }
      // 获取应用面板
      const getInitData=async()=>{
         let result=await getPanelLists().then(res=>res.data).catch(error=>error)
         appList.value=result.data
      }
      onMounted(()=>{
        getInitData()
      })
      return {
        handleMenu,
        active,
        appList,
        linkMenu,
        hideBox,
      };
    },
  };
</script>

<style lang="less" scoped>
  .application {
    position: relative;

    .hideMenuBox {
      position: absolute;
      width: ~`vw(793) `;
      min-height: ~`vh(800) `;
      background: rgb(5, 72, 106);
      z-index: 100;
      right: -61px;
      border-radius: 20px;
      color: #fff;
      padding: 20px;
      transform: scale(0);
      transition: all 0.6s;

      .ant-menu-item:hover {
        background-color: #fff;
      }

      .hideMenuTitle {
        font-size: 20px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
        line-height: 30px;
        text-align: left;
        border-bottom: 1px dashed rgb(56 113 142);
        margin-bottom: 30px;
      }

      .orderApps {
        width: 315px;
        height: 50px;
        border-radius: 5px;
        border: 1px dashed #fff;
      }
    }

    &:hover .hideMenuBox {
      transform: scale(1);
      transition: all 0.2s;
    }
  }

  .hideMenuList {
    line-height: 2 !important;
  }

  .hideMenuList .hideMenuItem {
    width: 97px;
    height: 98px;
  }

  .disabled {
    color: #ddd;
    cursor: not-allowed;
    filter: grayscale(0.5) opacity(0.5);
  }

  .top {
    display: flex;
    width: 100%;
    padding: 24px 100px;
    justify-content: flex-end;
    align-items: center;
    font-size: 14px;

    ul {
      display: flex;
      cursor: pointer;

      li {
        margin-right: 12px;
      }

      li:last-child {
        margin-right: 0px;
      }
    }
  }
</style>